import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 存储token
    Authorization: localStorage.Authorization || '',
    AccountName: localStorage.AccountName || '',
    RefreshToken: localStorage.RefreshToken || ''
  },
  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin (state, user) {
      try {
        state.Authorization = user.Authorization
        localStorage.setItem('Authorization', user.Authorization)
      } catch (err) {
        alert('当前客户端不支持,localstorage!')
      }
    },
    loginName (state, name) {
      try {
        state.AccountName = name.LoginName
        localStorage.setItem('AccountName', name.LoginName)
      } catch (err) {
        alert('当前客户端不支持,localstorage!')
      }
    },
    refreshtoken (state, token) {
      try {
        console.log('Store的Index.js中mutations下的freshtoken方法的参数state,token==>', state, token)
        localStorage.setItem('RefreshToken', token.refreshtoken)
      } catch (err) {
        alert('当前客户端不支持,localstorage!')
      }
    }

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js